<template>
  <div>
    <div>
      <fieldset>
        <legend>录入信息</legend>
        <div class="item">
          <label>
            <span class="item-label">项目名称：</span>
            <input v-model="name">
            <span class="item-tail"></span>
          </label>
        </div>
        <div class="item">
          <label>
            <span class="item-label">购买价格：</span>
            <span class="item-span">
              <input v-model="realTotal" v-price>
            </span>
            <span class="item-tail">元</span>
          </label>
        </div>
        <div class="item">
          <label>
            <span class="item-label">面积：</span>
            <span class="item-span">
              <input v-model="area" v-price="0">
            </span>
            <span class="item-tail"></span>
          </label>
        </div>
        <div class="item">
          <label>
            <span class="item-label">核定单价：</span>
            <span class="item-span">
              <input v-model="price" v-price>
            </span>
            <span class="item-tail">元</span>
          </label>
        </div>
        <div class="item">
          <label>
            <span class="item-label">持有年限：</span>
            <span class="item-span">
              <input v-model="year" v-price="0">
            </span>
            <span class="item-tail">年</span>
          </label>
        </div>
        <div class="item">
          <label>
            <span class="item-label">重置单价：</span>
            <span class="item-span">
              <input v-model="resetPrice" v-price>
            </span>
            <span class="item-tail">元</span>
          </label>
        </div>
      </fieldset>
      <fieldset class="form-set">
        <div class="item">
          <label>
            <span class="item-label">购买单价：</span>
            <input :value="toNumber(realPrice)" readonly>
            <span class="item-tail">元</span>
          </label>
        </div>
        <legend>计算价格</legend>
        <div class="item">
          <label>
            <span class="item-label">核定总价：</span>
            <input :value="toNumber(priceTotal)" readonly>
            <span class="item-tail">元</span>
          </label>
        </div>
      </fieldset>
      <fieldset class="form-set">
        <legend>计税情况</legend>
        <table class="hovertable">
          <tr>
            <th>计税方式</th>
            <th>增值税</th>
            <th>个人所得税</th>
            <th>土地增值税</th>
            <th>契税印花税</th>
            <th>合计税款</th>
          </tr>
          <tr v-for="(item,index) in list" :key="index">
            <td>{{item.name}}</td>
            <td class="cell-value">{{toNumber(item.zengzhi)}}</td>
            <td class="cell-value">{{toNumber(item.geren)}}</td>
            <td class="cell-value">{{toNumber(item.tudi)}}</td>
            <td class="cell-value">{{toNumber(item.qishui)}}</td>
            <td class="cell-value">{{toNumber(item.total)}}</td>
          </tr>
        </table>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'
import Price from '../directives/v-price.js'

export default {
  name: 'ui-basic',
  data () {
    return {
      name: '',
      realTotal: 0, // 实际价格
      area: 0, // 面积
      price: 0, // 核定单价
      year: 0,
      resetPrice: 0,
      list: [
        {
          name: '核定增收'
        },
        {
          name: '查账征收'
        },
        {
          name: '重置计税'
        }
      ]
    }
  },
  computed: {
    priceTotal () {
      let price = this.price
      let area = this.area
      return price > 0 && area > 0 ? price * area : 0
    },
    realPrice () {
      let total = this.realTotal
      let area = this.area
      return total > 0 && area > 0 ? total / area : 0
    }
  },
  mounted () {
    this.calculate = throttle(
      () => {
        this.doCalculate()
      },
      200,
      {
        trailing: true
      }
    )
  },
  methods: {
    doCalculate () {
      // <th>增值税</th>
      // <th>个人所得税</th>
      // <th>土地增值税</th>
      // <th>契税印花税</th>
      // <th>合计税款</th>
      // 核定征收
      this.list = []
      let item = this.getItem('核定征收')
      let value =
        (parseFloat(this.priceTotal) - parseFloat(this.realTotal)) * 0.056
      item.zengzhi = value > 0 ? value : 0
      item.geren = this.priceTotal * 0.03
      item.tudi = this.priceTotal * 0.06
      item.qishui = this.priceTotal * 0.031
      item.total = item.zengzhi + item.geren + item.tudi + item.qishui
      this.list.push(item)
      // 查账征收
      item = this.getItem('查账征收')
      value =
        (parseFloat(this.priceTotal) - parseFloat(this.realTotal)) * 0.056
      item.zengzhi = value > 0 ? value : 0
      value = (this.priceTotal - this.realTotal * 1.03) * 0.2
      item.geren = value > 0 ? value : 0
      item.qishui = this.priceTotal * 0.031
      let minusNumber = (1 + 0.03 + 0.05 * this.year) * this.realTotal
      let delta = this.priceTotal - minusNumber
      if (delta > 0 && delta <= 0.5 * minusNumber) {
        item.tudi = delta * 0.3
      } else if (delta > 0.5 * minusNumber && delta <= minusNumber) {
        item.tudi = delta * 0.4 - minusNumber * 0.05
      } else if (delta > 1 && delta <= 2 * minusNumber) {
        item.tudi = delta * 0.5 - minusNumber * 0.15
      } else if (delta > 200) {
        item.tudi = delta * 60 - minusNumber * 0.35
      } else {
        item.tudi = 0
      }
      item.total = item.zengzhi + item.geren + item.tudi + item.qishui
      this.list.push(item)
      // 重置计税
      item = this.getItem('重置计税')
      item.zengzhi = this.priceTotal * 0.056
      item.qishui = this.priceTotal * 0.031
      minusNumber = this.resetPrice * this.area
      delta = this.priceTotal - minusNumber
      if (delta > 0 && delta <= 0.5 * minusNumber) {
        item.tudi = delta * 0.3
      } else if (delta > 0.5 * minusNumber && delta <= minusNumber) {
        item.tudi = delta * 0.4 - minusNumber * 0.05
      } else if (delta > 1 && delta <= 2 * minusNumber) {
        item.tudi = delta * 0.5 - minusNumber * 0.15
      } else if (delta > 200) {
        item.tudi = delta * 60 - minusNumber * 0.35
      }
      item.total = item.zengzhi + item.geren + item.tudi + item.qishui
      this.list.push(item)
    },
    getItem (name) {
      return {
        name: name,
        zengzhi: 0,
        geren: 0,
        tudi: 0,
        qishui: 0,
        total: 0
      }
    },
    toNumber (num) {
      return num > 0 ? num.toFixed(2) : '0.00'
    }
  },
  directives: {
    Price
  },
  watch: {
    price () {
      this.$nextTick(() => {
        this.calculate()
      })
    },
    realTotal () {
      this.$nextTick(() => {
        this.calculate()
      })
    },
    area () {
      this.$nextTick(() => {
        this.calculate()
      })
    },
    year () {
      this.$nextTick(() => {
        this.calculate()
      })
    },
    resetPrice () {
      this.$nextTick(() => {
        this.calculate()
      })
    }
  }
}
</script>

<style>
.item {
  margin: 5px 2px;
  height: 25px;
  line-height: 25px;
}
.item-span {
  position: relative;
}
.v-price {
  position: absolute;
  top: -42px;
  left: 0px;
  line-height: 36px;
  height: 36px;
  min-width: 200px;
  background: #f5f2f4;
  border: solid 1px #9c9799;
  border-radius: 8px 10px 10px 0;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  padding-left: 5px;
}
.item-label {
  display: inline-block;
  width: 80px;
  text-align: left;
}
.item input {
  height: 15px;
  line-height: 15px;
  padding: 3px 5px;
  border: solid 1px #9c9799;
  min-width: 193px;
}
.item input[readonly] {
  background-color: #cdc9c9;
}
.item-tail {
  display: inline-block;
  width: 20px;
}
.form-set {
  margin-top: 15px;
}
table.hovertable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #999999;
  border-collapse: collapse;
  width: 100%;
}
table.hovertable th {
  background-color: #f0edee;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #8f8f8f;
}
table.hovertable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #8f8f8f;
}
table .cell-value {
  text-align: right;
}
@media only screen and (max-device-width: 480px),
  only screen and (min-device-width: 560px) and (max-device-width: 1136px) and (-webkit-min-device-pixel-ratio: 2) {
  .item input {
    min-width: 146px;
  }
  .v-price {
    min-width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui-basic.vue